<template src="./index.html"></template>

<script>
import { getdata } from './data.js';import com from '../../../../../comMapping.js';
export default {
	data() {
		return {
			showdelete: true,
			comMapping:com,
			riskInformation: {
				identificationCode: '91310000MA7FNAH0A',
				taxpayerRiskType: '',
				taxpayerCreditLevel: 'A',
				taxpayerEarlyWarningLevel: '',
				taxpayerRiskLogo: 'Y',
				updateTime: ''
			}
		};
	},
	mounted() {},
	created() {
		this.initialization();
	},
	methods: {
		forhideendelete() {
			this.showdelete = false;
		},
		forRouter() {},
		//更新基本信息
		UpdateBasicInformation() {
			this.$https.fetchPost('/natural/risk/updateNaturalBaSicInfo').then(res => {
				if (res.data.code == '200') {
					this.$message.success(res.data.message);
					this.initialization();
				} else {
					this.$message.error('更新基本信息错误：'+res.data.message);
				}
			});
		},
		//初始化
		initialization() {
			this.$https.fetchPost('/natural/risk/findNaturalRisk').then(res => {
				if (res.data.code == '200') {
					this.riskInformation=res.data.data
				} else {
					this.$message.error(res.data.message);
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
